(function () {
  "use strict";

  // Run only on product pages (covers product.default, product.custom, etc.)
  // Shopify sets template.name to 'product' on all product templates.
  var isProductTemplate =
    (window.Shopify && Shopify.theme && Shopify.designMode !== undefined && typeof window.template === "undefined")
      ? /(^| )template-product( |$)/.test(document.body.className) // fallback
      : (window.template && window.template.name === "product") || document.body.classList.contains("template-product");

  // Extra fallback: URL path check (works in previews too)
  if (!isProductTemplate && !/\/products\//.test(location.pathname)) return;

  var REDIRECT_URL = "https://docscontacts.com/pages/next-steps";
  var ADD_URL =
    (window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.cart_add_url) ||
    "/cart/add.js";

  function extractFormData(form, clickedButton) {
    var fd = new FormData(form);

    // Include clicked submit button (mirrors native behavior)
    if (clickedButton && clickedButton.name && !fd.has(clickedButton.name)) {
      fd.append(clickedButton.name, clickedButton.value || "");
    }

    // Ensure a variant id is present
    if (!fd.get("id")) {
      var idNode =
        form.querySelector('[name="id"][value]:checked') ||
        form.querySelector('[name="id"]') ||
        form.querySelector("[data-variant-id]");
      if (idNode) {
        fd.set("id", idNode.value || idNode.getAttribute("data-variant-id"));
      }
    }

    // Default quantity
    if (!fd.get("quantity")) fd.set("quantity", "1");

    return fd;
  }

  function addToCart(fd) {
    return fetch(ADD_URL, {
      method: "POST",
      headers: { Accept: "application/json" },
      body: fd,
      credentials: "same-origin"
    }).then(function (res) {
      if (!res.ok) {
        return res.json().catch(function () { return {}; }).then(function (json) {
          var msg = (json && (json.description || json.message)) || "Unable to add to cart.";
          throw new Error(msg);
        });
      }
      return res.json().catch(function () { return {}; });
    });
  }

  function addAndRedirect(fd) {
    addToCart(fd)
      .then(function () {
        window.location.href = REDIRECT_URL;
      })
      .catch(function (err) {
        alert(err && err.message ? err.message : "Unable to add to cart.");
      });
  }

  // Intercept product form submissions
  document.addEventListener(
    "submit",
    function (evt) {
      var form = evt.target;
      if (!form || !form.matches('form[action*="/cart/add"]')) return;

      evt.preventDefault();
      evt.stopImmediatePropagation();

      var clicked =
        (document.activeElement && form.contains(document.activeElement) && document.activeElement) || null;

      var fd = extractFormData(form, clicked);
      addAndRedirect(fd);
    },
    true // capture beats theme listeners
  );

  // Intercept button clicks that add to cart on product pages (some themes don’t submit the form)
  document.addEventListener(
    "click",
    function (evt) {
      var btn = evt.target.closest(
        'button, [type="submit"], [data-add-to-cart], .product-form__submit, [data-shopify="add-to-cart"], [data-action="add-to-cart"]'
      );
      if (!btn) return;

      // Disable dynamic checkout / Buy It Now on product pages (we want our redirect)
      if (
        btn.matches(
          ".shopify-payment-button__button, .shopify-payment-button__button--unbranded, [name='checkout']"
        )
      ) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        var buyNowForm = btn.closest('form[action*="/cart/add"]');
        if (buyNowForm) {
          var fdBuyNow = extractFormData(buyNowForm, btn);
          addAndRedirect(fdBuyNow);
        }
        return;
      }

      var form = btn.closest('form[action*="/cart/add"]');
      if (form) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        var fd = extractFormData(form, btn);
        addAndRedirect(fd);
      }
    },
    true
  );
})();
